import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Breakpoints:
 *  mobile:  < 600px  (MUI "sm")
 *  tablet:  600–1023px
 *  desktop: ≥ 1024px (MUI "lg" minus a notch — we use custom 1024 for sidebar threshold)
 */

export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}

export function useIsTablet(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between("sm", "lg"));
}

export function useIsDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("lg"));
}

/** True when filter panel should be shown as a drawer (mobile + tablet) */
export function useIsCompact(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("lg"));
}
